// src/components/pages/Privacy.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { pageService } from '../../services/api';

const Privacy = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await pageService.getPrivacy();
            setData(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching privacy data:', error);
            setData({
                title: 'Privacy Policy',
                content: 'This privacy policy describes how Indian News Paper & Media Association collects, uses, and protects your personal information. We are committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.',
                last_updated: '2024-01-01'
            });
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <section className="py-5">
            <Container>
                <Row>
                    <Col>
                        <h1 className="display-4 fw-bold mb-4">{data.title}</h1>
                        <div className="divider" style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #0056b3, #007bff)', marginBottom: '2rem' }} />
                        <div className="content">
                            <p className="lead">{data.content}</p>
                            <p className="text-muted mt-4">
                                <strong>Last Updated:</strong> {data.last_updated}
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Privacy;